/**
 * All Regex for validation declared here.
 */
export let CustomRegex = {
    password: /(?=^.{8,100}$)(?=.*\d)(?=.*[!@#$%^&*()])(?!.*\s)[0-9a-zA-Z!@#$%^&*()]*$/,
    email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    emailMultiple: /^(\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]{2,15}( *?,\s*?){1}( *)?)+$/,
    numberOnly: /^[0-9]{1,5}$/,
    macId: /^([0-9A-F]{2}[:]){5}([0-9A-F]{2})$/i,
    webLink: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
    allowNumberOnly: /^\+?\d{8,15}$/,
    allowAlphaNumericSpace: /^[A-Za-z0-9- ]+$/,
    allowAlphaNumericSpecialChars: /^[A-Za-z0-9@£$%&*!.:^’,()_=#~.\- \\/]+$/,
    allowChatChars: /^[A-Za-z0-9@£$%&*!.:^’,()?_=#~.\- \\\/]+$/,
    restrictSpace: /^[a-zA-Z]+[\-'\s]?[a-zA-Z ]+$/,
    address: /^(\w*\s*[\#\-\,\/\.\(\)\&]*)+ /,
    positiveNumber: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
    ip: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
    numericValue: /^[0-9]$/,
    decimalWithNigative: /^-?[0-9]\d*(\.\d+)?$/,
    energyEnvironment: /(?:\b|-)([1-9]{1,2}[0]?|100)\b/g,
    etPortNumber: /^[0-9]{1,65535}$/,
    unitRate: /^(0|[1-9]\d*)?(\.\d+)?$/,
    unitRates: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
    postcode: /^[A-Za-z0-9- ]{4,10}$/,
    etdecimalNumber: /^[+-]?[0-9]{1,9}(?:\.[0-9]{1,2})?$/,
    etNumber: /^(-{1}?(?:([0-9]{0,15}))|([0-9]{1})?(?:([0-9]{0,9})))?(?:\.([0-9]{0,9}))?$/,
    decimalNumbers: /^[+-]?[0-9]{1,9}(?:\.[0-9]{1,2})?$/,
    decimalNumber: /(100)|(0*\d{1,2})/,
    license: /^(|[1-9]\d*)$/,
    levels: /^([1-9]\d*)$/,
    twoDigitsAfterDecimal: /^(?:\d*\.\d{1,2}|\d+)$/,
    waitTime: /^([01]?[1-9]\d*)$/,
    negativePositiveDecimalNumber: /^\-?(\d+\.?\d*|\d*\.?\d+)$/,
    numberWithoutLimit: /^[0-9]+$/,
    positiveNumberUptoTwoDecimel: /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/,
    numberWithNegative: /^-?[0-9]\d*$/,
    url: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
    onlyNumers: /^[0-9]+$/
};
